import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  ModalItem,
  ButtonItem,
  ErrorItem,
  TextAreaItem,
  SwitchItem,
} from "../../../../Components/Items";

class ElegirObservaciones extends Component {
  dropdownRef = React.createRef();
  formRefbservaciones = React.createRef();
  containerRef = React.createRef(); // Wrapper relativo del textarea

  state = {
    loading: false,
    observacionesPasadas: [],
    observacionesValue: "",
    sugerencias: [],
    showSugerencias: false,
    activeIndex: -1,

    // Posición para el portal flotante
    dropPos: { top: 0, left: 0, width: 0 },
  };

  debounceTimer = null;

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside, true);
    window.addEventListener("resize", this.reposicionarDropdown, true);
    window.addEventListener("scroll", this.reposicionarDropdown, true);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, true);
    window.removeEventListener("resize", this.reposicionarDropdown, true);
    window.removeEventListener("scroll", this.reposicionarDropdown, true);
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      const obsRaw = Array.isArray(this.props.observacionesPasadas)
        ? this.props.observacionesPasadas
        : [];

      const idActual = this.props.clienteIdActual || this.props.proveedorIdActual;

      const mapUnicas = new Map();
      obsRaw.forEach((item) => {
        let obj;
        if (typeof item === "string") {
          obj = { texto: item.trim(), generica: true };
        } else if (item && item.texto) {
          obj = {
            texto: item.texto.trim(),
            id: item.clienteId || item.proveedorId, 
            nombre: item.nombreCliente || item.nombreProveedor,
            generica: false,
          };
        } else return;

        if (obj.texto && !mapUnicas.has(obj.texto)) {
          mapUnicas.set(obj.texto, obj);
        }
      });

      let unicas = Array.from(mapUnicas.values());

      unicas.sort((a, b) => {
        const esActualA = a.id === idActual;
        const esActualB = b.id === idActual;

        if (esActualA && !esActualB) return -1;
        if (!esActualA && esActualB) return 1;
        if (a.generica && !b.generica) return -1;
        if (!a.generica && b.generica) return 1;
        return 0;
      });

      const obsInicial = this.props.observaciones || "";
      const obsXmlInicial =
        this.props.observacionesXml !== undefined
          ? this.props.observacionesXml
          : false;

      this.formRefbservaciones.current?.setFieldsValue({
        observaciones: obsInicial,
        observacionesXml: obsXmlInicial,
      });

      this.setState({
        observacionesPasadas: unicas,
        observacionesValue: obsInicial,
        sugerencias: [],
        showSugerencias: false,
        activeIndex: -1,
      });
    }

    if (this.props.visible !== prevProps.visible && !this.props.visible) {
      this.setState({
        sugerencias: [],
        showSugerencias: false,
        activeIndex: -1,
      });
    }
  }

  reposicionarDropdown = () => {
    if (!this.state.showSugerencias) return;
    const node = this.containerRef.current;
    if (!node) return;

    const r = node.getBoundingClientRect();
    this.setState({
      dropPos: {
        top: r.bottom + 6,
        left: r.left,
        width: r.width,
      },
    });
  };

  handleClickOutside = (e) => {
    if (!this.state.showSugerencias) return;

    const inputWrap = this.containerRef.current;
    const dropdown = this.dropdownRef.current;

    const clickEnInput = inputWrap && inputWrap.contains(e.target);
    const clickEnDropdown = dropdown && dropdown.contains(e.target);

    if (!clickEnInput && !clickEnDropdown) {
      this.setState({ showSugerencias: false });
    }
  };

  setObservacionEnForm = (value) => {
    this.formRefbservaciones.current?.setFieldsValue({ observaciones: value });
  };

  filtrarSugerencias = (query) => {
    const q = (query || "").trim();
    const qUp = q.toUpperCase();

    if (!qUp) return this.state.observacionesPasadas.slice(0, 10);

    const starts = [];
    const includes = [];

    for (const o of this.state.observacionesPasadas) {
      const ou = (o.texto || "").toUpperCase();
      if (ou.startsWith(qUp)) starts.push(o);
      else if (ou.includes(qUp)) includes.push(o);
      if (starts.length + includes.length >= 10) break;
    }

    return [...starts, ...includes].slice(0, 10);
  };

  onChangeObservaciones = (e) => {
    const value = e?.target?.value ?? "";

    this.setState({
      observacionesValue: value,
      activeIndex: -1,
    });
    this.setObservacionEnForm(value);

    if (!this.state.showSugerencias) {
      this.setState({ showSugerencias: true }, this.reposicionarDropdown);
    }

    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      const sugerencias = this.filtrarSugerencias(value);
      this.setState(
        {
          sugerencias,
          showSugerencias: sugerencias.length > 0,
          activeIndex: -1,
        },
        this.reposicionarDropdown,
      );
    }, 120);
  };

  onFocusObservaciones = () => {
    const sugerencias = this.filtrarSugerencias(this.state.observacionesValue);
    this.setState(
      {
        sugerencias,
        showSugerencias: sugerencias.length > 0,
        activeIndex: -1,
      },
      this.reposicionarDropdown,
    );
  };

  seleccionarSugerencia = (sugerenciaObj) => {
    const texto = sugerenciaObj.texto;
    this.setState({
      observacionesValue: texto,
      sugerencias: [],
      showSugerencias: false,
      activeIndex: -1,
    });
    this.setObservacionEnForm(texto);
  };

  onKeyDownObservaciones = (e) => {
    const { showSugerencias, sugerencias, activeIndex } = this.state;

    if (!showSugerencias || !sugerencias.length) {
      if (e.key === "Escape") this.setState({ showSugerencias: false });
      return;
    }

    const max = sugerencias.length - 1;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      this.setState({
        activeIndex: activeIndex < 0 ? 0 : Math.min(max, activeIndex + 1),
      });
      return;
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      this.setState({
        activeIndex: activeIndex < 0 ? max : Math.max(0, activeIndex - 1),
      });
      return;
    }

    if (e.key === "Enter") {
      if (activeIndex >= 0) {
        e.preventDefault();
        const pick = sugerencias[activeIndex];
        if (pick) this.seleccionarSugerencia(pick);
      }
      return;
    }

    if (e.key === "Escape") {
      e.preventDefault();
      this.setState({ showSugerencias: false });
    }
  };

  renderSugerenciasPortal() {
    const { showSugerencias, sugerencias, activeIndex, dropPos } = this.state;
    if (!showSugerencias || !sugerencias.length) return null;

    const idMaestro = this.props.clienteIdActual || this.props.proveedorIdActual;
    const isProveedor = !!this.props.proveedorIdActual; // Bandera para saber si pintar la palabra cliente o proveedor en el tooltip

    const dropdown = (
      <div
        style={{
          position: "fixed",
          top: dropPos.top,
          left: dropPos.left,
          width: dropPos.width,
          zIndex: 2000,
          background: "#fff",
          border: "1px solid #e5e5e5",
          borderRadius: 6,
          boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
          maxHeight: 220,
          overflowY: "auto",
        }}
        ref={this.dropdownRef}
      >
        {sugerencias.map((sug, idx) => {
          const active = idx === activeIndex;
          const esActual = sug.id === idMaestro;

          // Colores
          let bgColor = active ? "#f5f5f5" : "#fff";
          if (esActual) {
            bgColor = active ? "#d9f7be" : "#f6ffed"; 
          }

          return (
            <div
              key={`${sug.texto}-${idx}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.seleccionarSugerencia(sug);
              }}
              style={{
                padding: "10px 12px",
                cursor: "pointer",
                background: bgColor,
                borderBottom:
                  idx === sugerencias.length - 1 ? "none" : "1px solid #f0f0f0",
              }}
            >
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  fontWeight: esActual ? "500" : "normal",
                }}
              >
                {sug.texto}
              </div>
              <div
                style={{
                  fontSize: "11px",
                  color: esActual ? "#389e0d" : "#8c8c8c",
                  marginTop: "4px",
                }}
              >
                {sug.generica
                  ? ""
                  : esActual
                    ? `• Usada con este ${isProveedor ? "proveedor" : "cliente"}`
                    : `• Usada con ${sug.nombre || (isProveedor ? "otro proveedor" : "otro cliente")}`}
              </div>
            </div>
          );
        })}
      </div>
    );

    return ReactDOM.createPortal(dropdown, document.body);
  }

  cerrarElegirObservaciones() {
    const observaciones =
      this.formRefbservaciones.current?.getFieldValue("observaciones") ??
      this.state.observacionesValue;
    const observacionesXml =
      this.formRefbservaciones.current?.getFieldValue("observacionesXml");

    this.props.cerrarElegirObservaciones(observaciones, observacionesXml);
    this.formRefbservaciones.current?.resetFields();

    this.setState({
      observacionesValue: "",
      sugerencias: [],
      showSugerencias: false,
      activeIndex: -1,
    });
  }

  onFinish() {
    this.cerrarElegirObservaciones();
  }

  onFinishFailed = (e) => {
    ErrorItem(e);
  };

  render() {
    return (
      <>
        <ModalItem
          title="Observaciones"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarElegirObservaciones.bind(this)}
          paddingTop
          width={700}
        >
          <Form
            ref={this.formRefbservaciones}
            name="elegirObservaciones"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Guardar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            {!this.props.noXml && (
              <FormItem
                name="observacionesXml"
                label="Observaciones XML"
                margin
                valuePropName="checked"
              >
                <SwitchItem />
              </FormItem>
            )}
            <FormItem name="observaciones" label="Observaciones" pattern margin>
              <div ref={this.containerRef}>
                <TextAreaItem
                  placeholder="Escribe las observaciones"
                  autoSize={{ minRows: 3, maxRows: 8 }}
                  value={this.state.observacionesValue}
                  onChange={this.onChangeObservaciones}
                  onKeyDown={this.onKeyDownObservaciones}
                  onFocus={this.onFocusObservaciones}
                  onClick={this.onFocusObservaciones}
                />
              </div>
            </FormItem>

            {/* El portal mágico */}
            {this.renderSugerenciasPortal()}

            {this.props.textoDinamicas && (
              <div class="styled-list">
                <h3>Textos dinámicos</h3>
                <table>
                  <tr>
                    <td>
                      <code>&lt;Mes&gt;</code>
                    </td>
                    <td>Mes de venta (Enero, Febrero, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesCo&gt;</code>
                    </td>
                    <td>Mes de venta corto (Ene, Feb, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesNum&gt;</code>
                    </td>
                    <td>Mes de venta en número (01, 02, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesAn&gt;</code>
                    </td>
                    <td>Mes anterior (Enero, Febrero, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesAnCo&gt;</code>
                    </td>
                    <td>Mes anterior corto (Ene, Feb, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesAnNum&gt;</code>
                    </td>
                    <td>Mes anterior en número (01, 02, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesSig&gt;</code>
                    </td>
                    <td>Mes siguiente (Enero, Febrero, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesSigCo&gt;</code>
                    </td>
                    <td>Mes siguiente corto (Ene, Feb, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesSigNum&gt;</code>
                    </td>
                    <td>Mes siguiente en número (01, 02, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;Anio&gt;</code>
                    </td>
                    <td>Año de venta (2025, 2026, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;Fecha&gt;</code>
                    </td>
                    <td>Fecha de venta (01/01/2025)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;Dia&gt;</code>
                    </td>
                    <td>Día de venta (01, 02, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;DiaSemana&gt;</code>
                    </td>
                    <td>Día de la semana (Lunes, Martes, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;SemanaLa&gt;</code>
                    </td>
                    <td>
                      Descripción semana empezando en Lunes (Ej. 28 abril al 4
                      mayo)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;SemanaAnLa&gt;</code>
                    </td>
                    <td>
                      Descripción semana anterior empezando en Lunes (Ej. 21 al
                      27 de abril)
                    </td>
                  </tr>
                </table>
              </div>
            )}
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ElegirObservaciones);